import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { registerLicense } from '@syncfusion/ej2-base';
import { setSpinner } from '@syncfusion/ej2-popups';

// environment.keys (syncfusionLicenseKey)
// registerLicense('Ngo9BigBOggjHTQxAR8/V1NAaF5cWWJCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWX5fdnRQRmNYWE1+Xko=');
//registerLicense("Ngo9BigBOggjHTQxAR8/V1NMaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXdccXRTRWVYWUd/WENWYUE="); //28.x.x
// registerLicense("Ngo9BigBOggjHTQxAR8/V1NCaF5cXmZCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXdfcnRQR2VYUkF+V0BWYU8="); // 26.1.35
// registerLicense("Ngo9BigBOggjHTQxAR8/V1NDaF5cWWtCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdlWX5cdnRQQ2JcV0dwX0dWYU4="); // 27.2.2

// registerLicense("Ngo9BigBOggjHTQxAR8/V1JGaF5cXGpCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdlWXxedHRQRmBZUUFzXkpWYE8="); //32.x.x
registerLicense("Ngo9BigBOggjHTQxAR8/V1JAaF5cX2pCd1p/TH5YfUNzdUVEY1ZUTXxaS1ZhSXxVdkxhUH5WcHFQR2JeUE19XEo="); //34.x.x



// Every Syncfusion spinner (grids, popups) uses this CSS-only template instead of the Material SVG spinner.
// The Material spinner animates with a 1 ms setTimeout loop that keeps running after the spinner is hidden;
// under zone.js each tick re-checks the whole app: ~500 change-detection passes a second on the Dashboard
// (measured 2026-10-14). A template has no JS animation. Styled in styles.scss (.rims-sf-spinner).
// Goes away with Syncfusion.
setSpinner({ template: '<div class="rims-sf-spinner"></div>' });

if (environment.production) {
  enableProdMode();
}

platformBrowser().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .catch(err => console.error(err));
